(ns hypnos.sleeplab.tile.field.consult-recommendations-note
  "Field for the note attached to the recommendations."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; helpers

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/note)]]
    [:div.field-body
     [:div.field
      [:div.control.is-expanded
       [:textarea.textarea
        {:rows        7
         :cols        70
         :max-length  4000
         :wrap        "soft"
         :disabled    disabled
         :placeholder (when-not disabled (tr :ui.placeholder/recommendations-note))
         :value       (get-in @state [:recommendations :note])
         :on-change   (fn [e]
                        (let [new-value (-> e .-target .-value)]
                          (swap! state assoc-in
                                 [:recommendations :note]
                                 new-value)))}]]]]]))
